import { useMemo } from 'react';
import { useConsultarTemaPorId } from '../use-consultar-tema-por-id/use-consultar-tema-por-id.hook';
import { UsePercentualProgressoHook } from './use-percentual-progresso-tema.types';

function mapPercentualToStatus(percentual: number | null): { label: string; status: string } {
  if (percentual === null || percentual === 0) {
    return { label: 'Não Estudado', status: 'default' };
  }
  if (percentual > 0 && percentual < 100) {
    return { label: 'Estudando', status: 'warning' };
  }
  if (percentual === 100) {
    return { label: 'Estudado', status: 'success' };
  }
}

export const usePercentualProgressoTema: UsePercentualProgressoHook = ({ idTema, idTurma }) => {
  const { tema, pendente, erro, retentativa } = useConsultarTemaPorId({
    idTema,
    idTurma,
  });

  const percentualProgresso = useMemo((): number | null => {
    if (!tema || tema.conteudos.length === 0) {
      return null;
    }

    const totalConteudos = tema.conteudos.filter((conteudo) => conteudo.conclusivel).length;

    if (totalConteudos === 0) {
      return null;
    }

    const totalConcluidos = tema.conteudos.filter((conteudo) => conteudo.statusConclusao?.concluido).length;

    return Math.round((totalConcluidos / totalConteudos) * 100);
  }, [tema]);

  const tagConteudo = useMemo(() => mapPercentualToStatus(percentualProgresso), [percentualProgresso]);

  return { percentualProgresso, tagConteudo, pendente, erro, retentativa };
};
